import React from "react";
import "./RolesInfoModal.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalTitle,
  OutsideClickModes,
} from "../../../components/Modal/Modal";

function RolesInfoModal({ onClose, openShareModal }) {
  const closeModal = () => {
    onClose();
    openShareModal();
  };

  return (
    <Modal
      className="roles-info-modal"
      onClose={closeModal}
      displayCancelButton
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle backBtnFunc={closeModal}>
        <IDHFormattedMessage id="ws_roles" defaultMessage="Roles" />
      </ModalTitle>
      <div className="roles-info-modal__permissions">
        <div className="roles-info-modal__column">
          <div className="roles-info-modal__role roles-info-modal__role--admin">
            <IDHFormattedMessage id="ws_admin" defaultMessage="Admin" />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_1"
              defaultMessage="Can add and remove Creators/Content/Publications/Actions"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_2"
              defaultMessage="Can see and modify all data sets"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_3"
              defaultMessage="Can share data sets to Clients"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_4"
              defaultMessage="Can invite Members and Clients"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_5"
              defaultMessage="Can assign other campaign Admins"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_admin_6"
              defaultMessage="Receives all campaign email notifications"
            />
          </div>
        </div>

        <div className="roles-info-modal__column">
          <div className="roles-info-modal__role roles-info-modal__role--moderator">
            <IDHFormattedMessage id="ws_moderator" defaultMessage="Moderator" />
          </div>

          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_moderator_1"
              defaultMessage="Can add and remove Creators/Content/Publications/Actions"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_moderator_2"
              defaultMessage="Can see and modify all data sets"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_moderator_3"
              defaultMessage="Can share data sets to Clients"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_moderator_4"
              defaultMessage="Receives all campaign email notifications"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_moderator_5"
              defaultMessage="Can invite Members and Clients"
            />
          </div>
        </div>

        <div className="roles-info-modal__column">
          <div className="roles-info-modal__role roles-info-modal__role--observer">
            <IDHFormattedMessage id="ws_observer" defaultMessage="Observer" />
          </div>

          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_observer_1"
              defaultMessage="Can add and remove Creators/Content/Publications/Actions"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_observer_2"
              defaultMessage="Can see and modify all data sets"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_observer_3"
              defaultMessage="Can share data sets to Clients"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_observer_4"
              defaultMessage="Receives campaign email notifications that personally concern him"
            />
          </div>
        </div>

        <div className="roles-info-modal__column">
          <div className="roles-info-modal__role roles-info-modal__role--client">
            <IDHFormattedMessage id="ws_client" defaultMessage="Client" />
          </div>

          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_client_1"
              defaultMessage="Can see only shared Creators/Content/Publications/Actions"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_client_2"
              defaultMessage="Can see and modify only shared data sets"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_client_3"
              defaultMessage="Can generate creator showcases with shared data"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_client_4"
              defaultMessage="Can export shared data to campaign PDF and XLSX reports"
            />
          </div>
          <div className="roles-info-modal__permission">
            <IDHFormattedMessage
              id="ws_roles_modal_permission_client_5"
              defaultMessage="Receives campaign email notifications that personally concern him"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export { RolesInfoModal };
